import { Check } from "lucide-react";
import { BRAND } from "@/lib/brand";

const TEAM_IMG =
  "https://customer-assets-agu9un31.emergentagent.net/job_33a9c3a1-f2a4-42eb-9986-662153705b4b/artifacts/slyz2795_Imports%20Parts%20-%20Cota%C3%A7%C3%A3o_image_img_3%20%281%29.jpg";

const PILLARS = [
  "Continuidade operacional",
  "Sourcing global e nacional",
  "Atendimento consultivo técnico",
  "Rastreabilidade e certificação",
];

export const About = () => {
  return (
    <section
      id="quem-somos"
      data-testid="about-section"
      className="relative py-24 lg:py-32 bg-mist"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          {/* Image side */}
          <div className="lg:col-span-6 reveal">
            <div className="relative">
              <div className="aspect-[4/5] rounded-3xl overflow-hidden border border-slate-200 shadow-2xl shadow-navy/10 relative">
                <img
                  src={TEAM_IMG}
                  alt="Especialista Imporparts em atendimento consultivo"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/40 via-transparent to-transparent" />
              </div>
              {/* floating stat */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl border border-slate-100 px-6 py-5 max-w-[220px] float-slow">
                <div className="text-4xl font-display font-bold text-navy leading-none">24h</div>
                <div className="text-sm text-slate-500 mt-1">
                  para responder cotações críticas
                </div>
              </div>
              <div className="absolute -top-6 -left-6 hidden md:flex items-center gap-3 bg-navy text-white rounded-2xl px-5 py-3 shadow-xl">
                <div className="w-2 h-2 rounded-full bg-gold animate-pulse" />
                <span className="tracking-eyebrow">Operação ativa 24/7</span>
              </div>
            </div>
          </div>

          {/* Copy side */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Quem Somos</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="about-title"
            >
              Somos a linha invisível
              <br />
              entre o problema e a solução.
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl reveal">
              A <strong className="text-navy">{BRAND.name}</strong> é especialista em
              <strong className="text-navy"> soluções corporativas e industriais</strong>. Fazemos
              engenharia de suprimentos, nacionalização de componentes, importação especializada e
              gestão de itens críticos — para que sua operação nunca pare.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {PILLARS.map((p, i) => (
                <div
                  key={p}
                  className="reveal flex items-start gap-3 bg-white rounded-xl border border-slate-200 px-5 py-4 card-lift"
                  data-testid={`about-pillar-${i}`}
                  style={{ transitionDelay: `${i * 60}ms` }}
                >
                  <div className="w-8 h-8 shrink-0 rounded-lg bg-navy text-white flex items-center justify-center">
                    <Check className="w-4 h-4" />
                  </div>
                  <div className="font-medium text-slate-800 leading-snug">{p}</div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-4 reveal">
              <a
                href={BRAND.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-cta-quote"
                className="btn-primary"
              >
                Solicitar Cotação
              </a>
              <a href="#como" data-testid="about-cta-process" className="btn-dark">
                Como Trabalhamos
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
